<template>
  <div id="goods">
    <div class="wrapper">
      <div class="top">
        <div class="mobileTop"></div>
        <div class="topPart">
          <span class="backToApp" @click="back()"></span>商品详情<i
            class="share"
          ></i>
        </div>
      </div>
      <div class="section section2">
        <swiper
          class="swiperGoods"
          v-if="goodsBanner.length >= 1"
          :options="swiperGoodsOptions"
          ref="swiperGoods"
        >
          <swiper-slide v-for="(value, index) in goodsBanner" :key="index">
            <div class="bannerImg">
              <img :src="value" />
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination" slot="pagination"></div>
      </div>
      <div class="section section3">
        <div class="price" v-show="firstGoodsInfo.telephone_bargain == 0">
          ￥
          <span class="c-price"
            >{{
              firstGoodsInfo.discount_price === undefined
                ? this.utils.keepPoint(firstGoodsInfo.original_price / 100)
                : this.utils.keepPoint(firstGoodsInfo.discount_price / 100)
            }}
          </span>
          <font class="innerFont" v-show="qiflag > 1">起</font>&nbsp;
          <span
            class="o-price"
            v-show="firstGoodsInfo.discount_price !== undefined"
            >￥{{
              this.utils.keepPoint(firstGoodsInfo.original_price / 100)
            }}</span
          >
          <img
            class="goods-comm-icon"
            src="./images/vip.png"
            alt=""
            srcset=""
          />
        </div>
        <!-- <div class="call" v-show="firstGoodsInfo.telephone_bargain == 1">电议</div> -->
        <div class="title">
          {{ goodsInfo.product_name }}
        </div>
      </div>
      <div class="section section5">
        <div class="sheader">
          <div class="left"></div>
          <div class="title">产品参数</div>
          <div class="right"></div>
        </div>
        <div class="row row1">
          <span>品&nbsp;牌&nbsp;名&nbsp;称&nbsp;&nbsp;&nbsp;</span
          >{{ goodsInfo.added.brand }}
        </div>
        <div class="row row2">
          <span>发货地&nbsp;&nbsp;&nbsp;</span
          >{{
            goodsInfo.added.province +
              goodsInfo.added.city +
              goodsInfo.added.area
          }}
        </div>
        <div v-if="goodsInfo.added.goods_material !== ''" class="row row3">
          <span
            >材&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;质&nbsp;&nbsp;&nbsp;</span
          >{{
            goodsInfo.added.goods_material === ""
              ? "暂无"
              : goodsInfo.added.goods_material
          }}
        </div>
        <div v-if="goodsInfo.added.mark !== ''" class="row row4">
          <span
            >备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注&nbsp;&nbsp;&nbsp;</span
          >{{ goodsInfo.added.mark === "" ? "暂无" : goodsInfo.added.mark }}
        </div>
      </div>
      <div class="section section6">
        <div class="sheader">
          <div class="left"></div>
          <div class="title">产品详情</div>
          <div class="right"></div>
        </div>
        <div
          class="introduce"
          id="contentIntroduce"
          v-html="goodsInfo.introduce"
        ></div>
      </div>
    </div>
    <div class="bottomBtn">
      <span class="btn" @click="showContect()">联系我们</span>
    </div>
    <el-dialog
      :visible.sync="checkContect"
      style="margin-top: calc(50% - 90px);"
    >
      <div class="top">联系我们</div>
      <div class="next">
        <div class="lb">
          <p class="phone">客服电话</p>
          <p class="phone num">400-1919-119</p>
          <p class="call">立即拨打</p>
        </div>
        <div class="rb">
          <div class="serve"></div>
          <p class="online" @click="serverClick()">在线客服</p>
        </div>
      </div>
      <div class="close" @click="checkContect = !checkContect"></div>
    </el-dialog>
  </div>
</template>

<script>
import goodsJson from './test.json'
export default {
  name: 'goods-detail',
  data () {
    return {
      testGoods: goodsJson,
      tabHeight: 0,
      checkContect: false,
      productName: '',
      numb: null,
      servicePhone: '4001919119',
      showLogin: false,
      isLogin: 0,
      showGoodsSelect: false,
      clickType: 0,
      goodsId: this.$route.query.goodsId, // 商品id
      businessId: this.$route.query.businessId, // 企业id
      goodsInfo: { added: {} },
      firstGoodsInfo: {},
      goodsBanner: [],
      businessInfo: {},
      authImgs: [],
      licenseImg: '',
      authInfo: '',
      cartCount: 0, // 购物车类型数量
      limitNumb: 1,
      qiflag: false,
      swiperGoodsOptions: {
        direction: 'horizontal',
        loop: false,
        autoplay: false,
        observer: true,
        observeParents: true,
        initialSlide: 0,
        on: {
          click: function () {
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      showHeader: true,
      isApp: 0
    }
  },
  methods: {
    serverClick () {
      this.YSF.init('1a5d46871ba2e8c628b5a7abe265ef26', {
        templateId: 123, // templateId表示自定义会话邀请的模板标识
        shuntId: 123, // shuntId表示访客选择多入口分流模版id
        sessionInvite: false, // sessionInvite表示是否开启会话邀请设置
        hidden: 1 // hidden表示是否隐藏访客端默认入口
      }).then(ysf => {
        ysf('open')
        // ysf('product', {
        //     show: 1,
        //     title: '任天堂（Nintendo）Switch游戏机',
        //     desc: '任天堂（Nintendo） Switch NS NX掌上游戏机便携 塞尔达马里奥新款游戏机 主机不锁 日版黑机彩色手柄+中文赛/塞尔达传说(指南+地图)',
        //     picture: 'https://img10.360buyimg.com/n5/s75x75_jfs/t4030/290/29851193/293745/d5e2b731/58ac3506Nbb57b5f6.jpg',
        //     note: '￥1978',
        //     url: 'https://www.taobao.com/',
        //     sendByUser: 0
        // })
      }).catch(error => {
        console.log(error)
        console.log('sdk加载失败')
      })
    },
    showContect () {
      this.checkContect = true
    },
    getAuthImgs: function () {
      var images = []
      // 企业认证图片
      if (this.businessInfo.tails.company === 1) {
        images.push(require('./images/icon-auth.png'))
      }
      // 资质图片
      if (this.businessInfo.tails.img !== undefined) {
        if (this.businessInfo.tails.img.indexOf(',')) {
          let array = this.businessInfo.tails.img.split(',')
          for (let i = 0; i < array.length; i++) {
            images.push('http://cdn.zxzx119.com/' + array[i])
          }
        } else {
          images.push('http://cdn.zxzx119.com/' + this.businessInfo.tails.img)
        }
      }
      this.authImgs = images
    },
    getAuthInfo: function () {
      let infoStr = ''
      infoStr = this.businessInfo.tails.company === 1 ? '企业认证 ' : ''
      infoStr += (this.businessInfo.tails.identity === 1 ? '身份认证 ' : '')
      for (let i = 0; i < this.businessInfo.tails.sign.length; i++) {
        let info = this.businessInfo.tails.sign[i]
        if (info.sign_type === '企业认证' && info.sign_status === '审核通过') {
          this.licenseImg = info.sign_file
        }
        if (info.sign_type === '资质认证' && info.sign_status === '审核通过') {
          infoStr += (this.businessInfo.tails.identity === 1 ? '资质认证 ' : '')
        }
      }
      if (infoStr === '') {
        infoStr = '未认证'
      }
      this.authInfo = infoStr
    },
    back () {
      this.$router.go(-1)
    },
    loadData () {
      // 商品信息
      let urlPath = this.accountUrl + '/goods/goodsDetail?goods_id=' + this.goodsId + '&userId=0'
      this.utils.GET(urlPath, (response) => {
        var result = response.data
        this.goodsInfo = response.data.goods
        this.firstGoodsInfo = this.goodsInfo.detailList[0]
        this.qiflag = this.goodsInfo.detailList.length
        // this.firstGoodsInfo = this.testGoods.detailList[0]
        // this.goodsInfo = this.testGoods
        // this.qiflag = this.testGoods.detailList.length
        this.goodsBanner = this.goodsInfo.product_cover.split(',')
        if (this.goodsBanner.length < 2) {
          this.swiperGoodsOptions.pagination.el = null
        }
        this.setImageInfo()
      })
      // 供应商 企业信息
      let urlPath2 = this.accountUrl + '/supplier/detail?id=' + this.businessId
      this.utils.GET(urlPath2, function (response) {
        // var result = response.data
        this.businessInfo = response.data
        this.getAuthImgs()
        this.getAuthInfo()
      })
    },
    setImageInfo () {
      // 图片处理
      setTimeout(() => {
        let conDom = document.getElementById('contentIntroduce')
        var maxWidth = document.body.clientWidth - 30
        if (maxWidth) {
          var myimg
          var imgs = conDom.querySelectorAll('img')
          for (let i = 0; i < imgs.length; i++) {
            myimg = imgs[i]
            myimg.width = maxWidth
            myimg.minHeight = '10px'
          }
        }
      }, 50)
    },
    getCartList () {
      var _this = this
      // 购物车列表
      let urlPath = this.companyUrl + '/shoppingCart/list?page=1&rows=999&type=2&order=1'
      this.utils.GET(urlPath, function (response) {
        var result = response.data.rows
        var countNum = 0
        for (let i = 0; i < result.length; i++) {
          countNum += result[i].list.length
        }
        _this.cartCount = countNum
      })
    },
    androidTabHeight (value) {
      // 设置android 模态导航条
      if (this.utils.isIphone() === true) {
        if (this.utils.isIphoneX() === true) {
          this.tabHeight = 20
        } else {
          this.tabHeight = 0
        }
      } else {
        this.tabHeight = parseInt(value)
      }
    },
    uaCheck () {
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
      let nowUrl = this.$router.history.current.path
      let iosApp = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
        navigator.userAgent
      )
      if (isiOS) {
        if (iosApp) {
          window.webkit.messageHandlers.toAppLogin.postMessage(nowUrl)
        } else {
          this.$router.replace({
            path: '/login'
          })
        }
      } else if (isAndroid) {
        if (window.zxzx) {
          // app内
          window.zxzx.toAppLogin(nowUrl)
        } else {
          // 浏览器内
          this.$router.replace({
            path: '/login'
          })
        }
      }
    },
    uaCart () {
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
      if (isiOS) {
        window.webkit.messageHandlers.toAppCar.postMessage(null)
      } else if (isAndroid) {
        // app内
        window.zxzx.toAppCar()
      }
    }
  },
  created () {
    this.loadData()
    this.$forceUpdate()
  },
  mounted () {
    document.body.scrollTop = document.documentElement.scrollTop = 0
  }
}
</script>

<style lang="scss" scoped>
#goods {
  font-size: 0;
}
.goods-comm-icon {
  width: 66px;
  height: 19px;
}
.wrapper {
  position: relative;
  background-color: #f6f6f6;
  .top {
    width: 100%;
    .mobileTop {
      height: 27px;
    }
    .topPart {
      display: inline-block;
      width: 100%;
      height: 40px;
      line-height: 40px;
      position: relative;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #1d2129;
      text-align: center;
      .backToApp {
        display: inline-block;
        position: absolute;
        left: 15px;
        top: 5px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: calc(50% - 6px);
          right: 0;
          margin: 0 auto;
          width: 12px;
          height: 12px;
          border-top: 2px solid #1d2129;
          border-left: 2px solid #1d2129;
          transform: rotate(-45deg);
        }
      }
      .share {
        position: absolute;
        right: 20px;
        width: 16px;
        height: 16px;
        top: 12px;
        background: url("./images/share.svg") no-repeat center center;
        background-size: cover;
      }
    }
  }
}
.bottomBtn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100px;
  background: #ffffff;
  z-index: 10;
  line-height: 65px;
  text-align: center;
  padding: 10px 16px;
  .btn {
    display: inline-block;
    width: 345px;
    height: 45px;
    border-radius: 4px;
    background: #9e918b;
    font-size: 15px;
    color: #ffffff;
    line-height: 45px;
  }
}
// <div class="bottomBtn">
//     <span class="btn">联系我们</span>
//   </div>
.section {
  position: relative;
  width: 100%;
  background-color: #ffffff;
  border-bottom: solid #f6f6f6 1px;
  box-sizing: content-box;
}
.section1 {
  height: 60px;
}
.section1 .title {
  position: absolute;
  top: 10px;
  left: 15px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #000000;
}
.section1 .title img {
  margin-left: 10px;
  width: 10px;
  height: 10px;
}
.section1 .auth {
  position: absolute;
  top: 35px;
  left: 15px;
  right: 15px;
  height: 10px;
}
.section1 .auth .image {
  margin-top: -5px;
  float: left;
  height: 10px;
  margin-left: 5px;
}
.section1 .auth .image img {
  top: 20px;
  height: 10px;
  width: auto;
}
.section1 .auth .image:first-of-type {
  margin-left: 0px;
}
.section2 {
  /*height: 300px;*/
  background-color: #f9f9f9;
}
.section2 .swiperGoods {
  width: 100%;
  /*height: 300px;*/
  overflow: hidden;
}
.section2 .swiperGoods .bannerImg {
  /*height: 300px;*/
  /*width: 100%;*/

  width: 100%;
  height: 0;
  margin: 0 auto;
  padding-top: 100%;
  background-color: #ffffff;
}
.section2 .swiperGoods .bannerImg img {
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.section3 {
  position: relative;
  padding-top: 1px;
  min-height: 50px;
  background-color: #ffffff;
}
.section3 .price {
  position: relative;
  margin: 10px 0 0 15px;
  height: 25px;
  line-height: 25px;
  font-size: 14px;
  color: #9e918b;
  .c-price {
    font-size: 21px;
    font-weight: bold;
  }
  .innerFont {
    font-size: 16px;
    color: #bdbdbd;
  }
  .o-price {
    font-size: 14px;
    color: #bebebe;
    text-decoration: line-through;
  }
}
.section3 .call {
  position: relative;
  margin: 10px 0 0 15px;
  height: 25px;
  font-size: 19px;
  font-weight: bold;
  color: #c41335;
}
.section3 .title {
  position: relative;
  margin: 5px 15px 13px 15px;
  min-height: 25px;
  line-height: 23px;
  font-size: 15px;
  color: #000000;
  font-weight: bold;
}
.section3 .freight {
  position: relative;
  margin: 5px 0 15px 15px;
  min-height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #000000;
  font-weight: bold;
}
.section3 .freight span {
  color: #808080;
}
.sheader {
  position: relative;
  height: 50px;
  width: 100%;
  background: #f6f6f6;
}
.sheader .left {
  position: absolute;
  left: 15px;
  top: 25px;
  height: 1px;
  width: calc(50% - 55px);
  background-color: #dadada;
}
.sheader .right {
  position: absolute;
  left: calc(50% + 40px);
  top: 25px;
  height: 1px;
  width: calc(50% - 55px);
  background-color: #dadada;
}
.sheader .title {
  position: absolute;
  top: 0px;
  left: calc(50% - 40px);
  width: 80px;
  height: 50px;
  line-height: 50px;
  font-size: 12px;
  color: #808080;
  text-align: center;
}
.section4 {
  height: 180px;
}
.section4 .row {
  margin-left: 15px;
  position: relative;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  color: #808080;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /*display: -webkit-box;*/
  /*-webkit-line-clamp: 2;*/
  /*-webkit-box-orient: vertical;*/
}
.section4 .row1 {
  margin-top: 5px;
}
.section4 .row span {
  color: #000000;
}
.section4 .row .none {
  color: #808080;
}
.section4 .row img {
  width: 20px;
  height: 14px;
}
.section5 {
  min-height: 180px;
}
.section5 .row {
  margin-left: 15px;
  position: relative;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  color: #000000;
}
.section5 .row1 {
  margin-top: 5px;
}
.section5 .row span {
  color: #808080;
}
.section6 {
  min-height: 100px;
}
.section6 .introduce {
  padding: 15px;
  min-height: 100px;
  font-size: 14px;
  color: #000000;
}

.bottomHeight {
  display: block;
  width: 100%;
  background: #ffffff;
}

>>> .section2 .swiper-pagination {
  position: absolute;
  bottom: 1px;
  width: 100%;
  height: 25px;
}
>>> .swiper-pagination .swiper-pagination-bullet {
  /*width: 8px;*/
  /*height: 8px;*/
  margin-left: 6px;
  background: #808080;
  opacity: 1;
}

>>> .swiper-pagination .swiper-pagination-bullet-active {
  background-color: #c41335;
}

/deep/ .el-dialog {
  position: relative;
  border-radius: 4px;
  width: 280px;
  height: 177px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    height: 100%;
    .top {
      display: inline-block;
      text-align: center;
      width: 100%;
      line-height: 50px;
      height: 50px;
      font-size: 17px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
      border-bottom: 1px solid #f2f2f2;
    }
    .next {
      display: inline-block;
      padding: 18px;
      height: calc(100% - 50px);
      width: 100%;
      font-size: 0;
      .lb {
        vertical-align: top;
        display: inline-block;
        width: 50%;
        height: 100%;
        padding-top: 10px;
        text-align: center;
        position: relative;
        .phone {
          height: 15px;
          line-height: 15px;
          font-size: 15px;
          text-align: center;
          margin-bottom: 10px;
          &.num {
            font-weight: bold;
          }
        }
        .call {
          padding-left: 20px;
          font-size: 14px;
          color: #9e918b;
          position: relative;
          &::before {
            content: "";
            position: absolute;
            width: 15px;
            height: 14px;
            left: 22px;
            top: 4px;
            background: url("./images/phone.svg") no-repeat center;
            background-size: contain;
          }
        }
        &::after {
          content: "";
          position: absolute;
          width: 1px;
          height: 100%;
          right: -1px;
          top: 0;
          background: #f2f2f2;
        }
      }
      .rb {
        vertical-align: top;
        display: inline-block;
        width: 50%;
        height: 100%;
        text-align: center;
        .serve {
          display: inline-block;
          width: 54px;
          height: 50px;
          background: url("./images/online.png") no-repeat center center;
          background-size: cover;
          margin-bottom: 15px;
        }
        .online {
          font-size: 14px;
          color: #9e918b;
        }
      }
    }
    .close {
      position: absolute;
      width: 30px;
      height: 30px;
      bottom: -100px;
      left: 0;
      right: 0;
      margin: 0 auto;
      background: url("./images/close.svg") no-repeat center;
      background-size: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/manman/goodsdetail.vue